'use client';

import { ProductComparisonNoticePopup } from '@vs-shop/commerce-ui/productComparisonNotice';
import { Popover, PopoverAnchor } from '@vs-shop/ui/popover';
import { useState } from 'react';

import { useIsProductInComparison } from '../../../../../../hook/useIsProductInComparison';

import ProductComparisonPopoverContent from './ProductComparisonPopoverContent';
import ProductPanelComparisonAdd from './ProductPanelComparisonAdd';
import { ProductPanelComparisonRemove } from './ProductPanelComparisonRemove';

type Props = {
  productCode: string;
};

export default function ProductPanelToolComparison({ productCode }: Props) {
  const [open, setOpen] = useState(false);

  const isInComparison = useIsProductInComparison(productCode);

  const handleAdded = () => {
    setOpen(true);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor>
        {isInComparison ? (
          <ProductPanelComparisonRemove productCode={productCode} />
        ) : (
          <ProductPanelComparisonAdd productCode={productCode} onAddedAction={handleAdded} />
        )}
      </PopoverAnchor>
      <ProductComparisonNoticePopup align="center">
        <ProductComparisonPopoverContent
          onCloseAction={() => {
            setOpen(false);
          }}
        />
      </ProductComparisonNoticePopup>
    </Popover>
  );
}
